import React, { useRef } from 'react';
import { MessageList } from 'react-chat-elements';
import 'react-chat-elements/dist/main.css';
import "./ChatDetails.css";
import _ from 'lodash';
// import TinyLoader from "../../Utils/TinyLoader/TinyLoader";
import ClosedSession from '../ClosedSession/ClosedSession';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import TinyLoader from '../../../../../Common/TinyLoader/TinyLoader';

const ChatDetails = ({
  activeSession,
  messages,
  messageText,
  hasMoreLiveChat,
  scrollLiveChatLoader,
  fetchLiveChatSessions,
  fullWidth,
  chatType
}) => {
  const divRef = useRef(null);
   

  const handleInfiniteScroll = (e) => {
    try {
        const { scrollTop } = e.target;
        const threshold = 100; // Load more when user is near the top

        if (scrollLiveChatLoader || !hasMoreLiveChat) return; // Prevent multiple API calls

        if (scrollTop <= threshold) {
            const previousHeight = e.target.scrollHeight; // Store previous scroll height

            fetchLiveChatSessions(true).then(() => {
                requestAnimationFrame(() => {
                    const newHeight = e.target.scrollHeight; // New height after messages load
                    e.target.scrollTop = e.target.scrollTop + (newHeight - previousHeight);
                });
            });
        }
    } catch (error) {
        console.error("Infinite Scroll Error:", error);
    }
};
  return (
    <div className={`chat-parent ${fullWidth ? "full-width" : ""}`}>
      {scrollLiveChatLoader ? (
        <div className="d-flex justify-content-center w-100 mt-4 mb-10">
          <TinyLoader />
        </div>
      ) : (
        ""
      )}
      
      <div>
        <MessageList
          className="live-chat-details"
          lockable={true}
          dataSource={messages}
          referance={divRef}
          onScroll={(e) => handleInfiniteScroll(e)}
          // onDownload={onDownloadHandler}
        />
          <ClosedSession />
      </div>
    </div>
  );
};

export default ChatDetails;
